import { z } from 'zod';
/** Contract for `GET /health`. Deliberately minimal: no versions, hosts or configuration. */
export const healthResponseSchema = z
    .object({
    status: z.literal('ok'),
    service: z.literal('sivan-api'),
    uptimeSeconds: z.number().int().nonnegative(),
})
    .strict();
//# sourceMappingURL=health.js.map